<template>
  <FlexCol gap-1>
    <Label :label="label" :required="required" :error="error" v-if="label" />
    <InputArc :error="error" :disabled="disabled" class="h-auto">
      <template #input>
        <textarea
          v-model="localValue"
          :disabled="props.disabled"
          type="text"
          :placeholder="props.placeholder"
          :minlength="minlength"
          :maxlength="maxlength"
          class="p-2 grow border-none bg-none bg-transparent focus:outline-none focus:ring-0 text-gray-700 w-full placeholder:italic"
          :class="{ 'text-red-500': props.error, 'bg-slate-200': props.disabled }"
          @blur="updateValue"
          :rows="props.rows">
        </textarea>
      </template>
    </InputArc>

    <Error :message="error" v-if="error" />
  </FlexCol>
</template>

<script setup>
import { watch, ref } from 'vue'

const props = defineProps({
  label: String,
  required: Boolean,
  disabled: Boolean,
  error: Array,
  modelValue: [String, Number],
  placeholder: String,
  rows: {
    type: [Number, String],
    default: 4,
  },
  minlength: [Number, String],
  maxlength: [Number, String],
})

const emits = defineEmits(['update:modelValue'])
const localValue = ref(props.modelValue)
const error = ref(props.error)

watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue
  }
)

watch(
  () => props.error,
  (newValue) => {
    error.value = newValue
  }
)

watch(localValue, (newValue) => {
  if (newValue == '') {
    newValue = null
  }
  emits('update:modelValue', newValue)
})
</script>
